module.exports = __webpack_public_path__ + "img/image-9.db9f7404.jpg";